module.exports = __webpack_public_path__ + "static/image-automation-2bf59db6c892fa5209365b88213f4783.svg";